export default __webpack_public_path__ + "static/triangle-dash-a08607604dd88389848c3ae9f28dc515.webp";